import { type PropsWithChildren, useMemo } from 'react'
import { AuthAccessContext } from '@/shared/api/authAccess'
import { getAuthHeaders } from '../auth/getAuthHeaders'
import { auth } from './FirebaseProvider'
import { useFirebaseProvider } from './useFirebaseProvider'

export const AuthAccessProvider = ({ children }: PropsWithChildren) => {
  const { user } = useFirebaseProvider()
  // ユーザー変更で関数の同一性も変え、進行中の旧操作を失効させる。
  const value = useMemo(
    () => ({
      userId: user?.uid,
      getHeaders: async () => {
        if (!user || auth.currentUser?.uid !== user.uid) throw new Error('ログインが必要です。')
        const headers = await getAuthHeaders()
        if (auth.currentUser?.uid !== user.uid) throw new Error('ログインユーザーが変更されました。')
        return headers
      },
    }),
    [user]
  )
  return <AuthAccessContext.Provider value={value}>{children}</AuthAccessContext.Provider>
}
